// imports react
import React, { useEffect, useState } from 'react';

//imports libraries
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';
import { userLogged } from '../userLogged';
import { MenuIcon } from 'lucide-react';
import axios from 'axios';

//imports components
import styles from '../styles/plans.module.css';
import stylesS from '../styles/switchmode.module.css';

import { Menu } from '../components/Menu';
import { urlAPI_Current } from "../config";
import { logoutUser } from '../logoutUser';
import { PlanBanner } from '../components/PlanBanner';
import Swal from 'sweetalert2';
import { verifyUserPaid } from '../verifyUserPaid';
import useAccessTracking from '../components/useAccessTracking';
import { verifyAuthToken } from '../verifyAuthToken';

export function Plans() {
    const navigateTo = useNavigate();

    const [userData, setUserData] = useState([]);
    const [isPaid, setIsPaid] = useState(false);
    const [planActually, setPlanActually] = useState(0);
    const [licenses, setLicenses] = useState(1);
    const [paymentType, setPaymentType] = useState("monthly");
    const [userCurrency, setUserCurrency] = useState("BRL");

    const [isLoading, setIsLoading] = useState(false);
    const [searchParams] = useSearchParams();
    let success = searchParams.get('success');
    let payPlan = searchParams.get('payPlan');

    const [darkMode, setDarkMode] = useState(() => 
      window.localStorage.getItem('darkMode') === 'true'
    );

    useAccessTracking();

    async function getUserLogged(){
      const user = await userLogged();
      setUserData(user)

      if (!user) { // não tiver usuário, ou authToken invalido
        toast.error('Faça o login primeiro');
        navigateTo('/login');
      } 
      else if(user.codTipoUsuario != 1){
        logoutUser();
        toast.error('Você não tem acesso a essa página');
        navigateTo('/login');
      } else { // loga
          const responsePaid = await verifyUserPaid();
          if(responsePaid.type == "convite"){
            navigateTo("/resultQuestionary");
            toast.success("Você possui um convite");
          } else if(responsePaid.success == true && responsePaid.type == "plano"){
            console.log(`Plano Atual ${responsePaid.plan}`);
            setIsPaid(true);
            setPlanActually(responsePaid.plan);
          } else {
            setIsPaid(false);
            setPlanActually(0);
          }
      }
    }
    
    async function sendCheckout(plan) {
      try { 
        setIsLoading(true);
        const payPlan = plan;

        if(payPlan == 2){
          const result = await Swal.fire({
            title: 'Plano em desenvolvimento',
            text: "Estamos em desenvolvimento desse plano! ",
            icon: 'warning',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'OK',
            didOpen: () => {
              const popup = Swal.getPopup();
              if (popup) {
                popup.style.backgroundColor = darkMode ? '#212121' : '#f0f0f0';
                const popupText = popup.querySelector('.swal2-title');
              if (popupText) {
                popupText.style.color = darkMode ? '#f0f0f0' : '#212121';
              }
      
              const popupTextContent = popup.querySelector('.swal2-html-container');
              if (popupTextContent) {
                popupTextContent.style.color = darkMode ? '#f0f0f0' : '#212121';
              }
              }
            }
          });
        } else {
          const responsePayment = await axios.post(
            `${urlAPI_Current}/checkoutStripe`,
            {
              payPlan: payPlan,
              paymentType: paymentType,
            }, {
              headers: {
                'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
              }
            }
          );
  
          const payment_url = responsePayment.data.linkPayment;
          
          toast.success("Direcionando para uma página segura!");
  
          window.open(`${payment_url}`, "_blank");
        }
      } catch (err) {
        console.log(err);
      }
    }

    async function accessSystem(planActually){
      navigateTo("/questionaryAlert");
    }

    useEffect(() => {
      getUserLogged();

      window.localStorage.setItem('darkMode', darkMode);
      document.documentElement.setAttribute('data-theme', darkMode ? 'dark' : 'light');
    }, [darkMode]);

    useEffect(() => {
        verifyAuthToken(navigateTo);
    }, []);

    return (
        <div className={styles.divPlans}>
            <Menu darkMode={darkMode}/>
            {isPaid ? (
              <>
              <div className={styles.divCenter}>
                <h1>Muito Obrigado!</h1>
                <p><span style={{color: "#03fc20"}}>Pagamento realizado com sucesso!</span> Agora você tem acesso na plataforma.</p>
                
                <div className={styles.planAccess}>
                  <p onClick={() => accessSystem(planActually)}>Acessar Plataforma</p>
                </div>

                <p><strong>Seu Plano:</strong></p>
              </div>
              <div className={styles.containerPlans}>
                <section className={styles.sectionPrice} id="plans">
                  <div className={styles.container}>
                    <div className="row justify-content-center">
                    {planActually == 1  
                        ? (
                            <PlanBanner
                              header="EvokPersona"
                              price={userCurrency == "BRL" ? "347,00" : "52,03"}
                              currency={userCurrency == "BRL" ? "RS" : "€"}
                              paymentType={paymentType}
                              features={[
                                { text: 'Relatório detalhado', isDisadvantage: false },
                                { text: 'Diagnóstico do perfil', isDisadvantage: false },
                                { text: 'Mapeamento de habilidades', isDisadvantage: false },
                                { text: 'Análise de padrões', isDisadvantage: false },
                                { text: 'Insights estratégicos', isDisadvantage: false },
                                { text: 'Recomendações práticas', isDisadvantage: false },
                                { text: 'Vantagem competiviva', isDisadvantage: false },
                                { text: 'Expansão do potencial', isDisadvantage: false },
                                { text: 'Impacto no mercado', isDisadvantage: false },
                                { text: 'Report <u>com</u> devolutiva', isDisadvantage: false }
                              ]}
                              sign={false}
                              plan={1}
                          />
                        ) : planActually == 2 ? (
                            <PlanBanner
                              header="EvokLicença"
                              price={userCurrency == "BRL" ? "250,00" : "37,49"}
                              currency={userCurrency == "BRL" ? "RS" : "€"}
                              paymentType={paymentType}
                              features={[
                                { text: 'Licenças exclusivas para facilitadores', isDisadvantage: false },
                                { text: 'Acesso via token Evok™ dedicado', isDisadvantage: false },
                                { text: 'Integração com cursos e workshops', isDisadvantage: false },
                                { text: 'Relatórios personalizados para sessões', isDisadvantage: false },
                                { text: 'Diagnóstico completo de performance', isDisadvantage: false },
                                { text: 'Avaliação cognitiva, relacional e emocional', isDisadvantage: false },
                                { text: 'Insights estratégicos para mentoria', isDisadvantage: false },
                                { text: 'Plano de desenvolvimento (PDI) orientado', isDisadvantage: false },
                                { text: 'Acesso a dados aplicáveis em grupo', isDisadvantage: false },
                                { text: 'Suporte exclusivo para facilitadores', isDisadvantage: false }
                              ]}
                              sign={false}
                              plan={2}
                          />
                        ) : null
                      }
                        </div>
                      </div>   
                    </section>
                  </div>
                  <div className={styles.planAccess}>
                    <p onClick={() => accessSystem(planActually)}>Acessar Plataforma</p>
                  </div>
                </>
            ) : (
              <>
              <div className={styles.divCenter}>
                    <h1>Planos Evok™</h1>
                    <p>Aproveite os valores <strong style={{color: "#03fc20"}}>ESPECIAIS</strong> de lançamento!</p>
                </div>
                <div className={styles.containerPlans}>
                  <section className={styles.sectionPrice} id="plans">
                      <div className={styles.container}>
                          <div className={styles.plansGrid}>
                              <PlanBanner
                                  header="EvokPersona"
                                  price={userCurrency == "BRL" ? "347,00" : "52,03"}
                                  currency={userCurrency == "BRL" ? "RS" : "€"}
                                  paymentType={paymentType}
                                  features={[
                                    { text: 'Relatório detalhado', isDisadvantage: false },
                                    { text: 'Diagnóstico do perfil', isDisadvantage: false },
                                    { text: 'Mapeamento de habilidades', isDisadvantage: false },
                                    { text: 'Análise de padrões', isDisadvantage: false },
                                    { text: 'Insights estratégicos', isDisadvantage: false },
                                    { text: 'Recomendações práticas', isDisadvantage: false },
                                    { text: 'Vantagem competiviva', isDisadvantage: false },
                                    { text: 'Expansão do potencial', isDisadvantage: false },
                                    { text: 'Impacto no mercado', isDisadvantage: false },
                                    { text: 'Report <u>com</u> devolutiva', isDisadvantage: false }
                                  ]}
                                  textButton="Comprar"
                                  sign={true}
                                  plan={1}
                                  onSignUp={sendCheckout}
                              />
                              <PlanBanner
                                  header="EvokLicença"
                                  price={userCurrency == "BRL" ? "250,00" : "37,49"}
                                  currency={userCurrency == "BRL" ? "RS" : "€"}
                                  paymentType={paymentType}
                                  features={[
                                    { text: 'Licenças exclusivas para facilitadores', isDisadvantage: false },
                                    { text: 'Acesso via token Evok™ dedicado', isDisadvantage: false },
                                    { text: 'Integração com cursos e workshops', isDisadvantage: false },
                                    { text: 'Relatórios personalizados para sessões', isDisadvantage: false },
                                    { text: 'Diagnóstico completo de performance', isDisadvantage: false },
                                    { text: 'Avaliação cognitiva, relacional e emocional', isDisadvantage: false },
                                    { text: 'Insights estratégicos para mentoria', isDisadvantage: false },
                                    { text: 'Plano de desenvolvimento (PDI) orientado', isDisadvantage: false },
                                    { text: 'Acesso a dados aplicáveis em grupo', isDisadvantage: false },
                                    { text: 'Suporte exclusivo para facilitadores', isDisadvantage: false }
                                  ]}
                                  textButton="Comprar"
                                  sign={true}
                                  plan={2}
                                  onSignUp={sendCheckout}
                              />
                          </div>
                      </div>   
                  </section>
              </div>
              </>
            )}
        </div>
    );
}
